// NPM MODULES
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { DateTime } from 'luxon';

// MUI COMPONENTS
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

import Loader from '../../common/Loader';

// NETWORKING
import useUserReportRequest from '../../../requests/UserReportRequest';

// FORMATTED MESSAGES
import UserReportsFormattedMessages from '../../../messages/reports/UserReportsFormattedMessages';

const SingleViewCallForwarding = (props) => {
  const { getCallDrilldown } = useUserReportRequest();
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    props.setPageTitle(UserReportsFormattedMessages.forwardedCalls);
    const fetchData = async () => {
      let { user, fromDate, toDate, errorHandler } = props;
      let calls = await getCallDrilldown(
        user.customer_user_id,
        fromDate.toMillis(),
        toDate.toMillis(),
        errorHandler
      );
      console.log('calls', calls);
      setCalls(calls);
      setLoading(false);
    };

    fetchData();
  }, [props.user, props.fromDate, props.toDate, props.errorHandler]);

  /*
    Adding the time range text fromDate to toDate
  */
  const generateTimeRangeText = () => {
    const fromDate = moment(props.fromDate.toMillis()).format(
      'DD MMM YYYY h:mm:ss A'
    );
    const toDate = moment(props.toDate.toMillis()).format(
      'DD MMM YYYY h:mm:ss A'
    );

    return (
      <Typography gutterBottom>
        {UserReportsFormattedMessages.from} {fromDate}{' '}
        {UserReportsFormattedMessages.to} {toDate}
      </Typography>
    );
  };

  const generateTable = () => {
    return (
      <TableContainer
        sx={{
          marginBottom: 4,
          overflowX: 'auto',
          width: '100%',
          whiteSpace: 'nowrap',
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell
                align="right"
                sx={{ borderRight: '1px solid' }}
                colSpan={3}
              >
                {UserReportsFormattedMessages.whenText}
              </TableCell>
              <TableCell align="right" colSpan={6}>
                {UserReportsFormattedMessages.dataText}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell align="right">
                {UserReportsFormattedMessages.callStart}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callEnd}
              </TableCell>
              <TableCell align="right" sx={{ borderRight: '1px solid' }}>
                {UserReportsFormattedMessages.callDuration}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callFromNumber}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callToNumber}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callForwardedToNumber}
              </TableCell>
              <TableCell align="right">
                {UserReportsFormattedMessages.callStatus}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{generateTableBody()}</TableBody>
        </Table>
      </TableContainer>
    );
  };

  const generateTableBody = () => {
    if (!calls || calls.length === 0) return null;

    return calls.map((call, i) => {
      let startDate = DateTime.fromISO(call.call_start_time)
        .setZone(localStorage.getItem('timeShort'), {
          keepLocalTime: false,
        })
        .toFormat('dd-LLL-yyyy h:mm:ss a');

      let endDate = DateTime.fromISO(call.call_end_time)
        .setZone(localStorage.getItem('timeShort'), {
          keepLocalTime: false,
        })
        .toFormat('dd-LLL-yyyy h:mm:ss a');

      return (
        <TableRow key={'list' + i + call.email_id} id={call.email_id}>
          <TableCell align="right" name="startDate">
            {startDate}
          </TableCell>
          <TableCell align="right" name="endDate">
            {endDate}
          </TableCell>
          <TableCell align="right" name="duration">
            {call.duration}
          </TableCell>
          <TableCell align="right" name="callFrom">
            {call.call_from}
          </TableCell>
          <TableCell align="right" name="callTO">
            {call.call_to}
          </TableCell>
          <TableCell align="right" name="forwardedTo">
            {call.forwarded_to}
          </TableCell>
          <TableCell align="right" name="callStatus">
            {call.call_status}
          </TableCell>
        </TableRow>
      );
    });
  };

  return (
    <>
      {generateTimeRangeText()}
      {loading ? <Loader /> : <>{generateTable()}</>}
    </>
  );
};

export default SingleViewCallForwarding;
